import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WritingService } from './writing.service';
import { ErrorAndSuggestion } from '../../shared/types/ErrorAndSuggestion';

@Component({
  selector: 'lp2-writing',
  templateUrl: './writing.component.html',
  styleUrls: ['./writing.component.scss'],
})
export class WritingComponent implements OnInit {
  @ViewChild('backdrop') backdrop: ElementRef;

  maxLength = 550;
  textRemainingChars = 0;
  textValue = '';
  lastTextValue: string;
  highlightedText = '';
  highlights = this.textValue;
  errorsAndSuggestions: ErrorAndSuggestion[] = [];

  private loading: boolean;

  constructor(private writingService: WritingService) {}

  ngOnInit() {
    this.updateRemainingCharsLength();
  }

  handleInput(event: any) {
    if (this.errorsAndSuggestions.length) {
      this.errorsAndSuggestions = [];
    }
    const { target } = event;
    this.textValue = target.value;
    this.updateRemainingCharsLength();
    this.highlights = this.applyHighlights(this.textValue);
  }

  handleScroll(event) {
    const { target } = event;
    const scrollTop = target.scrollTop;
    this.backdrop.nativeElement.scrollTop = scrollTop;
  }

  replaceAtRange(s, start, end, substitute) {
    return s.substring(0, start) + substitute + s.substring(end);
  }

  adjustRemainingErrors(afterIndex: number, adjustment: number) {
    this.errorsAndSuggestions.forEach((eas, index) => {
      if (eas.fromIndex >= afterIndex) {
        this.errorsAndSuggestions[index].fromIndex += adjustment;
        this.errorsAndSuggestions[index].toIndex += adjustment;
      }
    });
  }

  replaceErrorWithSuggestion(index) {
    const obj = this.errorsAndSuggestions[index];
    this.textValue = this.replaceAtRange(this.textValue, obj.fromIndex, obj.toIndex, obj.suggestion);
    this.errorsAndSuggestions.splice(index, 1);
    this.adjustRemainingErrors(obj.toIndex, obj.suggestion.length - obj.error.length);
    this.updateRemainingCharsLength();
    this.checkText();
    this.errorsAndSuggestions = [];
  }

  applyHighlights(text: string): string {
    let newText = text;
    const highlightList = [];
    this.errorsAndSuggestions.forEach((eas, index) => {
      const previousMarksAdditions = '<mark></mark>'.length * index;
      const fromIndex = eas.fromIndex + previousMarksAdditions;
      const toIndex = eas.toIndex + previousMarksAdditions;
      const word = text.substring(eas.fromIndex, eas.toIndex);
      const alreadyHighlighted = highlightList.find(
        (highlight) => highlight.fromIndex === eas.fromIndex && highlight.toIndex === eas.toIndex
      );
      if (!alreadyHighlighted) {
        newText = this.replaceAtRange(newText, fromIndex, toIndex, '<mark>' + word + '</mark>');
        highlightList.push({ fromIndex: eas.fromIndex, toIndex: eas.toIndex });
      }
    });
    return newText;
  }

  checkText() {
    if (this.textValue === '' || this.textValue === this.lastTextValue) {
      return;
    }
    this.startLoading();
    this.textValue = this.textValue.replace(/\s+$/, '').replace(/’/g, `'`);
    this.writingService.checkText(this.textValue).subscribe(
      (result) => {
        this.stopLoading();
        const corrections = (result.corrections && result.corrections.correction) || [];
        this.errorsAndSuggestions = [];
        for (const correction of corrections) {
          if (correction.suggestions.suggestion) {
            this.errorsAndSuggestions.push({
              error: correction.mistakeText,
              suggestion: correction.suggestions.suggestion[0].text,
              fromIndex: correction.mistakeTextFromIndex,
              toIndex: correction.mistakeTextToIndex + 1,
            });
          }
        }

        this.highlights = this.applyHighlights(this.textValue);
      },
      (error) => {
        this.stopLoading();
        console.error('Error: ' + error);
      }
    );
  }

  isButtonDisabled() {
    return this.isLoading() || this.errorsAndSuggestions.length > 0;
  }

  isLoading(): boolean {
    return this.loading;
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  private updateRemainingCharsLength() {
    this.textRemainingChars = this.maxLength - this.textValue.length;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/writing/writing.component.ts